import React from 'react'

const styles = {
  root: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row'
  },
  inner: {
    padding: '50px 0',
    width: '100%',
    borderTop: 'solid 1px #E7E7E7'
  }
}

const Section = ({ children, style, innerStyle, ...rest }) =>
  <div style={{ ...styles.root, ...style }} {...rest}>
    <div style={{ ...styles.inner, ...innerStyle }}>
      { children }
    </div>
  </div>

export default Section



// WEBPACK FOOTER //
// ./src/components/Section.js